"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.getQueryParam = void 0;
var getQueryParam = exports.getQueryParam = function getQueryParam(name) {
  var url = window.location.href;
  var regex = new RegExp('[?&]' + name + '(=([^&#]*)|&|#|$)');
  var results = regex.exec(url);
  if (!results) return null;
  if (!results[2]) return '';
  return decodeURIComponent(results[2].replace(/\+/g, ' '));
};